import { render, staticRenderFns } from "./UpgradePricingTile.vue?vue&type=template&id=15c09bec"
import script from "./UpgradePricingTile.vue?vue&type=script&lang=ts"
export * from "./UpgradePricingTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports